import React, { useState } from "react";
import { useData } from "../../../context/DataContext";
import AdminDataTable from "../components/AdminDataTable";
import { Shield, Clock, User, Activity } from "lucide-react";

const AuditLogsPage = () => {
  const { auditLogs } = useData();

  // Columns definition
  const columns = [
    {
      header: "Timestamp",
      key: "timestamp",
      render: (row) => (
        <div className="flex items-center text-sm text-slate-500">
          <Clock size={14} className="mr-1.5" />
          {new Date(row.timestamp).toLocaleString()}
        </div>
      )
    },
    {
      header: "Actor",
      key: "actorName",
      render: (row) => (
        <div className="flex items-center">
            <div className="w-6 h-6 rounded-full bg-slate-100 flex items-center justify-center mr-2 border border-slate-200">
                <User size={12} className="text-slate-500"/>
            </div>
            <span className="font-medium text-slate-700">{row.actorName}</span>
        </div>
      )
    },
    {
      header: "Action",
      key: "action",
      render: (row) => (
        <span className={`px-2 py-1 text-xs font-semibold rounded-full border ${
            row.action.includes("DELETE") || row.action.includes("SUSPEND") ? "bg-red-50 text-red-700 border-red-200" :
            row.action.includes("CREATE") || row.action.includes("ADD") ? "bg-green-50 text-green-700 border-green-200" :
            "bg-blue-50 text-blue-700 border-blue-200"
        }`}>
          {row.action}
        </span>
      )
    },
    {
      header: "Target",
      key: "targetName",
      render: (row) => <span className="text-sm font-medium text-slate-600">{row.targetName}</span>
    },
    {
      header: "Details",
      key: "details",
      render: (row) => <span className="text-sm text-slate-500 truncate max-w-xs block" title={row.details}>{row.details}</span>
    }
  ];

  return (
    <div>
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-3xl font-bold text-slate-800">System Audit Logs</h1>
          <p className="text-slate-500 mt-1">
            Track strict system activity, security events, and data modifications.
          </p>
        </div>
        <div className="flex items-center gap-2 px-3 py-1.5 bg-slate-100 rounded-lg text-sm font-medium text-slate-600">
            <Shield size={16} className="text-emerald-600"/>
            <span>Immutable Record</span>
        </div>
      </div>

      <AdminDataTable
        title="Recent Activity"
        columns={columns}
        data={auditLogs}
        searchableFields={["actorName", "action", "targetName", "details"]}
        filterableFields={[
            { key: "action", label: "Action Type", options: ["SYSTEM_INIT", "SUSPEND_USER", "ACTIVATE_USER", "CREATE_ROLE", "DELETE_ROLE", "IMPERSONATE", "LOGIN"] }
        ]}
      />
    </div>
  );
};

export default AuditLogsPage;
